import React, { useState, useEffect } from "react";
import api from "../../../api";
import Banner from "./include/Banner";

const API_URL = `${process.env.REACT_APP_API_URL}/api/research/publications`;
const API_BASE_URL = process.env.REACT_APP_API_URL;

const ResearchPublications = () => {
  const [pubData, setPubData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPubData = async () => {
      try {
        const response = await api.get(API_URL);
        setPubData(response.data.publications);
      } catch (err) {
        console.error("Error fetching publications:", err);
        setError("Failed to load publications data.");
      } finally {
        setLoading(false);
      }
    };

    fetchPubData();
  }, []);

  if (loading || error || !pubData) return null;

  const { images, heading, pdfs } = pubData.content;
  const defaultIcon = "/assets/images/excel.png";

  return (
    <>
      <Banner bannerImages={images} heading={heading} />

      <section>
        <div className="container ">
          <div className="row mb-5">
            <div className="col-md-12">
              <div className="res-content">
                <div className="sec-title text-center">
                  <h2> {heading}</h2>
                </div>

                <div className="row justify-content-center">
                  {pdfs.map((pdf, index) => (
                    <div key={index} className="col-md-4 col-12 mb-3">
                      <div className="card d-flex flex-row shadow-sm">
                        <div
                          className="p-2"
                          style={{
                            padding: "8px",
                            borderRight: "1px solid rgba(0, 0, 0, 0.125)",
                            borderRadius: "10px 0px 0px 10px",
                          }}
                        >
                          <img
                            src={defaultIcon}
                            alt="Excel Icon"
                            className="img-fluid"
                            style={{
                              width: "70px",
                              height: "70px",
                              objectFit: "cover",
                            }}
                          />
                        </div>

                        <div className="d-flex align-items-center p-2">
                          <a
                            href={`${API_BASE_URL}/public/${pdf.file}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-decoration-none text-dark"
                          >
                            <strong>{pdf.title}</strong>
                          </a>
                        </div>
                      </div>
                    </div>
                  ))}

                  {pdfs.length === 0 && (
                    <div className="col-12">
                      <p>No publication files available at this time.</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ResearchPublications;
